/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Reference_TitleInputs */

const en_us2_body_assessment_reference_title = /** @type {(inputs: Body_Assessment_Reference_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reference reading (optional)`)
};

const pt_br2_body_assessment_reference_title = /** @type {(inputs: Body_Assessment_Reference_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medição de referência (opcional)`)
};

const es_419_body_assessment_reference_title = /** @type {(inputs: Body_Assessment_Reference_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medición de referencia (opcional)`)
};

const pt_pt2_body_assessment_reference_title = /** @type {(inputs: Body_Assessment_Reference_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medição de referência (opcional)`)
};

const fr_fr2_body_assessment_reference_title = /** @type {(inputs: Body_Assessment_Reference_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesure de référence (facultatif)`)
};

const de_de2_body_assessment_reference_title = /** @type {(inputs: Body_Assessment_Reference_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referenzmessung (optional)`)
};

const it_it2_body_assessment_reference_title = /** @type {(inputs: Body_Assessment_Reference_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misurazione di riferimento (facoltativa)`)
};

/**
* | output |
* | --- |
* | "Reference reading (optional)" |
*
* @param {Body_Assessment_Reference_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_reference_title = /** @type {((inputs?: Body_Assessment_Reference_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Reference_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_reference_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_reference_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_reference_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_reference_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_reference_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_reference_title(inputs)
	return en_us2_body_assessment_reference_title(inputs)
});
export { body_assessment_reference_title as "body-assessment.reference_title" }